//https://infinite-scroll.com/

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getNextPage(uri, key, value) {
    var nextPage = updateQueryStringParameter(uri,'page',value);
    if (window.infScrollsFinished == true) {
        return false;
    } else if (window.infScrollsLoaded.includes(nextPage))
        return getNextPage(uri,'page',value + 1);

    return nextPage;
}

window.infScrollsLoaded = [];
window.infScrollsFinished = false;

var infData = {
    container: '.grid-uniform',
    path: function() {
        var url = window.location.href;

        var pageNum = getParameterByName('page');
        if (pageNum == null || pageNum == '')
            pageNum = 1;
        pageNum = parseInt(pageNum);

        var nextPage =  getNextPage(url,'page',pageNum + 1);

        return nextPage;
    },
    append: '.grid-product',
    history: 'replace',
    scrollThreshold: 100,
    hideNav: '.pagination',
    status: false
};
var infScrollEl = document.querySelector(infData.container);
$(infScrollEl).on( 'request.infiniteScroll', function( event, path, fetchPromise ) {
    window.infScrollsLoaded.push(path);
    var lastItem = document.querySelector('.grid-product:last-child');
    if (lastItem != null && !lastItem.classList.contains('last-of-page')) {
        lastItem.classList.add('last-of-page');
        lastItem.setAttribute('data-inf-path',path);
    } else if (lastItem != null) {
        window.infScrollsFinished = true;
    }
});
$(infScrollEl).on( 'history.infiniteScroll', function( event, title, path ) {
    if (typeof window.infScroll == 'undefined' || typeof window.infScroll.scrollPages == 'undefined')
        return;
    for (var i = 0; i < window.infScroll.scrollPages.length; i++) {
        var infPageLastItem = document.querySelector('.grid-product[data-inf-path="'+window.infScroll.scrollPages[i].path+'"]');
        if (infPageLastItem == null)
            continue;
        window.infScroll.scrollPages[i].top = infPageLastItem.offsetTop;
    }
    if (
        typeof window.infScroll.scrollPages[0] !== 'undefined' && 
        typeof window.infScroll.scrollPages[1] !== 'undefined'
    )
        window.infScroll.scrollPages[0].top = window.infScroll.scrollPages[0].top - 1;
});
$(infScrollEl).on( 'append.infiniteScroll', function( event, body, path, items, response ) {
    //Run Currency Conversion here
    if (typeof DoublyGlobalCurrency !== 'undefined') {
        DoublyGlobalCurrency.convertAll(DoublyGlobalCurrency.currentCurrency,'.money');
    }
});
window.infScroll = new InfiniteScroll( 
    infScrollEl, 
    {
        path: infData.path,
        append: infData.append,
        history: infData.history,
        scrollThreshold: infData.scrollThreshold,
        hideNav: infData.hideNav,
        status: infData.status
    }
);
